import React from "react";

import { Box, Container, Stack, Typography } from "@mui/material";

import ActionBar from "@app/analytics/components/ActionBar";
import DateSelector from "@app/analytics/components/DateSelector";
import PlanChip from "@app/analytics/components/PlanChip";
import useBillingContext from "@app/analytics/hooks/billing/useBillingContext";
import { usePageTitle } from "@app/utils/hooks";

import MeetingManager from "./MeetingManager";
import MeetingScheduler from "./MeetingScheduler";
import Participation from "./Participation";
import TimeKeeper from "./TimeKeeper";
import { WorkspaceOverviewProvider } from "./WorkspaceOverviewProvider";
import WorkspaceOverviewUpsell from "./WorkspaceOverviewUpsell";

const ModuleRow = ({
  children,
}: {
  children: React.ReactNode | React.ReactNode[];
}) => (
  <Stack
    direction={{ xxs: "column", lg: "row" }}
    sx={{ width: "100%" }}
    spacing={3}
  >
    {children}
  </Stack>
);

const WorkspaceOverview = () => {
  usePageTitle("Workspace Overview");

  const { currentPlan, isTrial } = useBillingContext();

  const isInFreePlan = currentPlan.type === "free";

  return (
    <WorkspaceOverviewProvider>
      <Box sx={{ width: "100%", bgcolor: "#FFF", height: "100%", pb: 5 }}>
        <ActionBar>
          <Stack direction="row" spacing={2} alignItems="center">
            <Typography variant="h2">Workspace Overview</Typography>
            {isInFreePlan || isTrial ? <PlanChip label="Pro" /> : null}
          </Stack>
          <DateSelector fixedRange="30" />
        </ActionBar>
        {isInFreePlan ? (
          <WorkspaceOverviewUpsell />
        ) : (
          <Container maxWidth="xl" sx={{ width: "100%", pt: 3 }}>
            <Stack spacing={3}>
              <ModuleRow>
                <TimeKeeper />
                <MeetingScheduler />
              </ModuleRow>
              <ModuleRow>
                <MeetingManager />
                <Participation />
              </ModuleRow>
            </Stack>
          </Container>
        )}
      </Box>
    </WorkspaceOverviewProvider>
  );
};

export default WorkspaceOverview;
